export default __webpack_public_path__ + "static/media/gallery_04.a66d23b5.jpg";